<template>
  <tr :class="{ 'not-viewed': row.view_count == 0 }">
    <td v-for="(column, r) in columns" :key="r">
      <!-- Alert type -->
      <span
        v-if="
          viewedByPatient &&
            column.name === 'passport' &&
            tableType !== 'pathology'
        "
        class="table-label"
        :style="
          alertType
            ? 'background-color: #01a87a;top:24px;'
            : 'background-color: #01a87a;'
        "
      >
        מטופל צפה
      </span>

      <span
        v-if="alertType && column.name === 'passport'"
        class="table-label"
        :style="row.alert_type != 'בהול' ? 'background-color: #f67e3e;' : ''"
      >
        {{ row.alert_type }}
      </span>

      <!-- 'Scheduled by' icon -->
      <slot v-if="column.name === 'scheduled_by'">
        <span>{{ getAppScheduledByText(row[column.name]) }}</span>
      </slot>

      <!-- Surgery name -->
      <slot v-else-if="column.name === 'title'">
        <span class="td-surgery-name" @click="openEventPage">
          {{ row[column.name] }}
        </span>
      </slot>

      <slot v-else-if="column.name === 'documents_count'">
        <div class="relative">
          <div v-if="row[column.name] === '-'" @click="openEventPage">
            -
          </div>
          <button class="view-files-btn" v-else @click.stop="openFilesPopup">
            <span class="flex">
              <img src="/assets/img/svg/ic-file-blue.svg" />
              {{ tableType === "pathology" ? "פתיחת המסמך" : "הצגת מסמכים" }}
            </span>
          </button>
        </div>
      </slot>

      <slot v-else-if="column.name === 'patient_phone'">
        <a
          class="phone-text"
          :href="`tel:${row[column.name]}`"
          @click.stop="null"
          style="font-size: 1rem;"
        >
          {{ row[column.name] }}
          <img src="/assets/img/svg/ic-phone.svg" />
        </a>

        <a class="phone-text" @click.stop="openWhatsapp(row[column.name])">
          <img src="/assets/img/svg/wts.svg" alt="" />
        </a>
      </slot>

      <slot v-else-if="column.name === 'patient_view_status'">
        <div class="docs-table flex">
          <div class="doc-table-container relative">
            <div
              class="doc-table-label"
              :style="
                viewedByPatient ? 'background-color: #01a87a;color: white;' : ''
              "
            >
              {{ viewedByPatient ? "צפה" : "לא צפה" }}
            </div>
            <div>דוח פתולוגיה</div>
          </div>
          <div class="doc-table-container relative">
            <div
              class="doc-table-label"
              :style="
                row.located_report === 'צפה'
                  ? 'background-color: #01a87a;color: white;'
                  : ''
              "
            >
              {{ row.located_report }}
            </div>
            <div>סיכום תוצאות</div>
          </div>
        </div>
      </slot>

      <!-- Is available online -->
      <slot
        v-else-if="
          column.name === 'is_available_online' && tableType === 'pathology'
        "
      >
        <div class="docs-table flex">
          <div
            class="doc-table-container"
            :class="{
              available: row.is_available_online === 'זמין',
              unavailable: row.is_available_online === 'לא זמין'
            }"
          >
            <div class="doc-table-label">דוח פתולוגיה</div>
            {{ row.is_available_online }}
          </div>
          <div
            class="doc-table-container availability-change-btn"
            :class="{ disabled: row.is_available_online !== 'זמין' }"
            @click.stop="toggleAvailability"
          >
            <!-- {{ isUpdatingAvailability ? "מעדכן..." : "שנה זמינות" }} -->
            {{ resendButtonText }}
          </div>
        </div>
      </slot>

      <!-- Regular cells -->
      <slot v-else :name="column" :value="row[column]">
        <div
          @click="openEventPage"
          :style="
            column.name === 'passport' && viewedByPatient && alertType
              ? 'padding-right: 35px;'
              : ''
          "
        >
          {{ row[column.name] }}
        </div>
      </slot>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";
import Error from "../Popups/Error.vue";
import Files from "../Popups/Files.vue";
import { downloadDocument } from "../../utilities/download-document.js";
import { mapMutations } from "vuex";
import Whatsapp from "../Popups/Whatsapp.vue";

export default {
  props: {
    row: { type: Object, required: true },
    columns: { type: Array, required: true },
    tableType: { required: true }
  },
  data() {
    return {
      files: [],
      isUpdatingAvailability: false,
      wasSent: false
    };
  },
  computed: {
    ...mapGetters(["activeDoctor"]),
    viewedByPatient() {
      return (
        this.row && this.row.viewed_by_patient && this.row.viewed_by_patient > 0
      );
    },
    alertType() {
      return this.row && this.row.alert_type && this.row.alert_type !== "רגיל";
    },
    resendButtonText() {
      if (!this.row) return "שלח מחדש";
      if (this.isUpdatingAvailability) return "שולח...";
      if (this.wasSent) return "נשלח";
      return "שלח מחדש";
    }
  },
  methods: {
    ...mapMutations(["UPDATE_FILE_WATCHED"]),
    /**
     * @param {Boolean} value
     */
    async openFilesPopup() {
      // download document
      if (this.row.path) {
        try {
          await downloadDocument(this.row.path, this.row.file);
          this.UPDATE_FILE_WATCHED(this.row.path);
        } catch (error) {
          this.$modal.show(Error, {
            title: "התרחשה שגיאה, אנא נסו שנית מאוחר יותר"
          });
        }
        return;
      }
      // need api call for document path
      this.$modal.show(Files, {
        tableType: this.tableType,
        eventId: this.row.id
      });
    },
    /**
     * Activated by clicking on a row. Opens
     * the event page by id.
     *
     */
    openEventPage() {
      if (!this.row.id) return;
      let routeName = "";
      if (this.row.pathologyType) {
        routeName =
          this.row.pathologyType == "appointment" ? "app-info" : "surg-info";
      } else {
        routeName = this.tableType == "appointment" ? "app-info" : "surg-info";
      }
      this.$router.push({ name: routeName, params: { id: this.row.id } });
    },
    /**
     * @param {String | undefined} type from event.
     * Usually called scheduled_by.
     *
     * @returns {String} text (alt of image).
     */
    getAppScheduledByText(type) {
      const imageObj = this.$store.getters["getAppScheduledBy"](type, false);
      if (imageObj === null) return "-";
      return imageObj.text;
    },
    openWhatsapp(phone) {
      this.$modal.show(Whatsapp, { patientPhone: phone });
    },
    async toggleAvailability() {
      if (this.isUpdatingAvailability) return;

      this.isUpdatingAvailability = true;

      try {
        // Convert text back to boolean for API call
        const currentAvailability = this.row.is_available_online === "זמין";

        await this.$API.updatePathologyAvailability(
          this.row.row_id,
          currentAvailability,
          this.activeDoctor.license,
          this.activeDoctor.id
        );

        // Toggle the text value
        // this.row.is_available_online =
        //   this.row.is_available_online === "זמין" ? "לא זמין" : "זמין";

        // Mark as sent successfully
        this.wasSent = true;
      } catch (error) {
        this.$modal.show(Error, {
          title: "שגיאה בעדכון הזמינות, אנא נסו שנית"
        });
      } finally {
        this.isUpdatingAvailability = false;
      }
    }
  }
};
</script>
